import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBX10dKFv1ypbFisi6aLFII1LjqsnAUcco",
  authDomain: "hrm-project-58de3.firebaseapp.com",
  projectId: "hrm-project-58de3",
  storageBucket: "hrm-project-58de3.firebasestorage.app",
  messagingSenderId: "709295688707",
  appId: "1:709295688707:web:a1ef7f419bca506be05236",
  measurementId: "G-S63CT93BNX"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);